/**
 * Cómo se pinta cada tono de estado, para los componentes portados.
 *
 * ─── 🔴 Por qué existe este archivo y no se escribe el token a mano ──────────
 *
 * El sistema arma sus tokens concatenando: `"var(--color-" + tone + ")"`. En
 * este repo eso está mal **dos veces**:
 *
 * 1. **El formato.** `--color-danger` y sus tres hermanos son CANALES sueltos
 *    (`239 68 68`), así que `var(--color-danger)` a secas produce
 *    `background: 239 68 68`, que el navegador descarta en silencio. En cambio
 *    `--color-danger-surface` y toda la familia de siete roles SÍ son colores
 *    completos, porque en oscuro llevan alpha. O sea la mitad va envuelta en
 *    `rgb()` y la otra mitad no.
 *
 * 2. **El tono.** Hasta el 2026-09-30 `--color-info` valía **azul** y la
 *    familia `info-*` **violeta**, así que un punto `info` al lado de una
 *    superficie `info` quedaba azul sobre violeta. Se unificó en violeta:
 *    medido, el azul tenía 4 usos contra 108 de la familia, y era el color de
 *    la marca anterior. `estados.test.ts` fija que no se vuelvan a separar.
 *
 * El relleno sigue saliendo de **`--color-{tono}-solid`**, que pertenece a la
 * misma familia que la superficie y ya es un color completo.
 */

export type Tono = 'info' | 'success' | 'warning' | 'danger'

/** El color de relleno: puntos, barras, indicadores. Nunca texto sobre claro. */
export const tonoSolido = (tono: Tono) => `var(--color-${tono}-solid)`

/** El fondo suave de un aviso. */
export const tonoSuperficie = (tono: Tono) => `var(--color-${tono}-surface)`

/** El texto sobre esa superficie, con contraste ya resuelto en los dos temas. */
export const tonoTexto = (tono: Tono) => `var(--color-${tono}-content)`
